<template>
  <div class="contentBox">
    <div class="contentBlock fade-in-section">
      <img :src="bannerImg" class="bannerImgItem" />
    </div>
    <div class="contentBlock fade-in-section">
      <div class="RichText" v-html="text"></div>
    </div>
  </div>

</template>

<script>
import "./index.css";
import bannerImg from "@/page/cptthanhvancompany/components/img/protocol1.png";

export default {
  data(){
    return{
      bannerImg,
      text:`
Chào mừng bạn đến với VânLend – ứng dụng được phát triển và vận hành bởi CPT THANH VAN JOINT STOCK COMPANY. Chúng tôi cam kết bảo vệ quyền riêng tư của người dùng. Chính sách quyền riêng tư này giải thích cách chúng tôi thu thập, sử dụng, lưu trữ và bảo vệ thông tin cá nhân của bạn khi bạn sử dụng ứng dụng của chúng tôi.

1. Thông tin chúng tôi thu thập
Khi bạn sử dụng ứng dụng VânLend, chúng tôi có thể thu thập các loại thông tin sau:
Dữ liệu cá nhân: Họ tên, ngày sinh, số CMND/CCCD, địa chỉ cư trú, số điện thoại và địa chỉ email.
Thông tin liên hệ khẩn cấp: Họ tên người liên hệ, số điện thoại và mối quan hệ với bạn.
Dữ liệu tài chính: Thu nhập, tài khoản ngân hàng, thông tin việc làm.
Dữ liệu thiết bị: Loại thiết bị, hệ điều hành, địa chỉ IP, mã định danh thiết bị và dữ liệu kết nối.

2. Quyền Bắt buộc
Để cung cấp dịch vụ tốt hơn và đảm bảo hiệu suất ứng dụng tối ưu, VânLend có thể yêu cầu thiết bị của bạn các quyền sau:
Hình ảnh
Khi người dùng gửi biểu mẫu phản hồi, liên hệ với bộ phận chăm sóc khách hàng hoặc tải lên ảnh chụp màn hình về sự cố, chúng tôi sẽ thu thập thông tin ảnh mà họ chọn tải lên. Thông tin này sẽ được mã hóa và sẽ không được tiết lộ nếu không có sự cho phép của người dùng.

Máy ảnh
Nếu bạn đồng ý, VânLend chỉ có thể truy cập máy ảnh của thiết bị để thực hiện các chức năng cần thiết trong ứng dụng, chẳng hạn như chụp ảnh các tài liệu cần thiết để xác minh danh tính hoặc tải lên hình ảnh liên quan đến ứng dụng của bạn. Quyền truy cập camera sẽ không được sử dụng cho bất kỳ mục đích nào khác và hình ảnh thu thập được sẽ được lưu trữ an toàn trên máy chủ của chúng tôi (https://www.second.cptthanhvancompany.com/). Chúng tôi sẽ không bao giờ chia sẻ dữ liệu này với bên thứ ba mà không có sự cho phép của bạn. 

Vị trí
Với sự đồng ý của bạn, VânLend có thể truy cập vị trí gần đúng của thiết bị của bạn chỉ với mục đích cải thiện bảo mật, ngăn chặn gian lận và đánh giá rủi ro hiệu quả hơn. Tùy chọn này hoàn toàn tự nguyện và bạn có thể chọn bật hay không. Nếu bạn đồng ý, thông tin vị trí sẽ được xử lý và lưu trữ an toàn trên máy chủ của chúng tôi (https://www.second.cptthanhvancompany.com/) và sẽ không được sử dụng cho bất kỳ mục đích nào khác. Dữ liệu vị trí của bạn sẽ không được chia sẻ với bên thứ ba mà không có sự đồng ý rõ ràng của bạn.

Thông tin thiết bị
Với sự cho phép của bạn, VânLend sẽ thu thập dữ liệu kỹ thuật từ thiết bị của bạn, bao gồm model, hệ điều hành, mã định danh duy nhất và các thông số cần thiết khác để đảm bảo việc sử dụng ứng dụng an toàn và hiệu quả. Dữ liệu này sẽ chỉ được sử dụng để cải thiện hiệu suất, ngăn chặn gian lận và giải quyết các sự cố kỹ thuật tiềm ẩn. Thông tin thiết bị sẽ được xử lý và lưu trữ an toàn trên máy chủ của chúng tôi (https://www.second.cptthanhvancompany.com/) và sẽ không được chia sẻ với bên thứ ba mà không có sự đồng ý trước của bạn.

Quyền truy cập tin nhắn SMS
Ứng dụng có thể yêu cầu quyền truy cập một số tin nhắn SMS trên thiết bị của bạn, chỉ để thu thập thông tin liên quan đến giao dịch tài chính như xác nhận chuyển tiền, thông báo thanh toán từ ngân hàng hoặc ví điện tử. Thông tin này giúp đánh giá khả năng tín dụng và phòng ngừa rủi ro. Chúng tôi không đọc, lưu trữ hoặc chia sẻ các tin nhắn cá nhân không liên quan.

Quyền truy cập lịch
Ứng dụng có thể yêu cầu quyền truy cập lịch của bạn để hỗ trợ nhắc nhở ngày đến hạn thanh toán. Việc này giúp bạn tránh trễ hạn và duy trì lịch sử tín dụng tốt. Dữ liệu lịch không được chia sẻ với bên thứ ba và chỉ được sử dụng trong phạm vi chức năng nhắc nhở.

Quyền truy cập danh sách ứng dụng
VânLend có thể thu thập danh sách các ứng dụng đã cài đặt trên thiết bị của bạn nhằm phục vụ mục đích đánh giá hành vi tín dụng và phát hiện rủi ro gian lận. Thông tin này sẽ được mã hóa và chỉ sử dụng nội bộ để hỗ trợ quy trình xét duyệt. Chúng tôi cam kết không chia sẻ dữ liệu này với bên ngoài.

3. Sử dụng Thông tin
Chúng tôi sử dụng thông tin thu thập được để:
-Xử lý và đánh giá đơn xin vay.
-Xác minh danh tính người dùng.
-Quản lý tài khoản và cung cấp hỗ trợ khách hàng.
-Ngăn chặn gian lận và đảm bảo an toàn cho người dùng.
-Tuân thủ luật pháp và quy định thuế hiện hành.
-Gửi thông báo, khuyến mãi và cập nhật về các dịch vụ của chúng tôi.

4. Chia sẻ Thông tin
VânLend có thể chia sẻ thông tin của bạn với:
-Các tổ chức tài chính và cơ quan tín dụng nhằm mục đích đánh giá khả năng tín dụng của bạn.
-Các nhà cung cấp dịch vụ giúp chúng tôi vận hành ứng dụng.
-Các cơ quan chính phủ theo yêu cầu của pháp luật.
-Các bên thứ ba được ủy quyền với sự đồng ý trước của người dùng.

5. Bảo mật Thông tin
Chúng tôi triển khai các biện pháp bảo mật kỹ thuật và tổ chức để bảo vệ thông tin của bạn khỏi bị truy cập trái phép, mất mát hoặc thay đổi. Tuy nhiên, người dùng cũng nên thực hiện các biện pháp phòng ngừa, chẳng hạn như không chia sẻ thông tin đăng nhập của họ.

6. Lưu giữ và Xóa Dữ liệu
Chúng tôi sẽ lưu giữ thông tin của bạn khi cần thiết để thực hiện các mục đích được nêu trong chính sách này và tuân thủ các nghĩa vụ pháp lý. Thông tin người dùng sẽ được lưu giữ tối đa năm năm sau khi mối quan hệ của bạn với VânLend kết thúc, trừ khi các quy định hiện hành yêu cầu thời gian lưu giữ lâu hơn. Nếu bạn muốn xóa tài khoản và dữ liệu cá nhân, bạn có thể liên hệ với Dịch vụ Khách hàng của chúng tôi theo địa chỉ online@cptthanhvancompany.com.

7. Quyền của Người dùng
Bạn có quyền:
-Truy cập, chỉnh sửa hoặc xóa dữ liệu cá nhân của mình.
-Phản đối việc chúng tôi xử lý thông tin của bạn.
-Rút lại sự đồng ý của bạn bất cứ lúc nào.
-Khiếu nại với cơ quan bảo vệ dữ liệu thích hợp.
-Bạn có thể thực hiện các quyền này bằng cách liên hệ với chúng tôi theo địa chỉ online@cptthanhvancompany.com.

8. Thay đổi Chính sách Quyền riêng tư
Chúng tôi có quyền sửa đổi chính sách này bất cứ lúc nào. Chúng tôi sẽ thông báo cho người dùng về những thay đổi quan trọng thông qua ứng dụng hoặc email.

9. Thông tin Liên hệ
Nếu bạn có bất kỳ câu hỏi nào về Chính sách Quyền riêng tư này, vui lòng liên hệ với đội ngũ hỗ trợ của chúng tôi.
Công ty: CPT THANH VAN JOINT STOCK COMPANY
Trang web của công ty:https://www.cptthanhvancompany.com/
Email: online@cptthanhvancompany.com
Giờ làm việc: 9:00 sáng đến 6:00 chiều
Địa chỉ: Lô CN-08, Cụm công nghiệp Thanh Vân, Xã Thanh Vân, Huyện Hiệp Hoà, Tỉnh Bắc Giang`
    }
  },
  mounted() {
    this.InitPage();
  },
  methods: {
    InitPage(){
      window.scrollTo({ top: 0 });
      const fadeInSections = document.querySelectorAll('.fade-in-section');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
      });
    }, {
        threshold: 0.01
    });
      fadeInSections.forEach(section => {
          observer.observe(section);
      });
    }
  },
};
</script>

<style scoped>
.RichText {
  white-space: pre-wrap;
  font-size: 18px;
  color: #333333;
  padding: 80px 160px 80px 160px;
  padding-top: 0px;
}
</style>
